<template>
    <div>
        <div class="nav-vertical">
			<ul class="nav nav-tabs nav-left" role="tablist">
				<li class="nav-item">
					<a class="nav-link active" v-bind:href="'#t1'+rowData.xmlctelot_id+''" role="tab" data-toggle="tab">
						<span class="nav-link-in">
							Detalhes
							<i class="fa fa-bulding"></i>
						</span>
					</a>
				</li>
                <li class="nav-item">
                  <a class="nav-link" v-bind:href="'#t2'+rowData.xmlctelot_id+''"role="tab" data-toggle="tab">
                    <span class="nav-link-in">
                      Documentos
                      <i class="fa fa-bulding"></i>
                    </span>
                  </a>
                </li>
			</ul>

			<div class="tab-content">
				<div role="tabpanel" class="tab-pane fade in active show"  v-bind:id="'t1'+rowData.xmlctelot_id+''">
                        <table class="table" id="mais">
                            <thead>
                                <tr>
                                    <th v-if="rowData.versao!==null" style="width: 20%">Versão</th>
                                    <th v-if="rowData.tp_ambiente!==null" style="width: 20%">Ambiente</th>
                                    <th v-if="rowData.uf!==null" style="width: 20%">UF</th>
                                    <th v-if="rowData.versao_app!==null" style="width: 20%">Versão APP</th>
                                    <th v-if="rowData.inf_recibo!==null" style="width: 20%">Inf. Recibo</th>
                                </tr>
                             </thead>
                             <tbody>
                                 <tr class="bg-gray-light" style="display: table-row;">
                                    <td v-if="rowData.versao!==null">
                                        {{ rowData.versao }}
                                    </td>
                                    <td v-if="rowData.tp_ambiente!==null">
                                        {{ rowData.tp_ambiente }}
                                    </td>
                                    <td v-if="rowData.uf!==null">
                                        {{ rowData.uf.nome }}
                                    </td>
                                    <td v-if="rowData.versao_app!==null">
                                        {{ rowData.versao_app }}
                                    </td>
                                    <td v-if="rowData.inf_recibo!==null">
                                        {{ rowData.inf_recibo }}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                </div><!--.tab-pane-->
                <div role="tabpanel" class="tab-pane fade"  v-bind:id="'t2'+rowData.xmlctelot_id+''">
                  <table class="table" id="mais">
                      <thead>
                          <tr>
                              <th style="width: 30%">N° Fiscal</th>
                              <th style="width: 40%">Chave CTE</th>
                              <th style="width: 40%">Status</th>
                              <th style="width: 10%">XML</th>
                              <th style="width: 10%">Ações</th>
                          </tr>
                       </thead>
                       <tbody>
                           <tr class="bg-gray-light" style="display: table-row;" v-for="item in rowData.doc_cte_xml">
                               <td>
                                   {{ item.num_fiscal }}
                               </td>
                              <td>
                                  {{ item.doc_cte.chave }}
                              </td>
                              <td>
                                  {{ item.status }}
                              </td>
                             <td>
                               <a @click="onVerXml(item.xml_cte)" v-b-tooltip title="Ver XML"><i class="fa fa-plus"></i></a>
                             </td>
                              <td>
                                <a @click="onReenvioXml(item.docctexml_id)" v-b-tooltip title="Reenviar XML"><i class="fa fa-repeat "></i></a>
                              </td>
                          </tr>
                      </tbody>
                  </table>
                </div><!--.tab-pane-->
			</div><!--.tab-content-->
		</div>
    </div>
  </template>

  <script>
  export default {
      data () {
        return {
          helpForm: new Form({statusRecord: [], params: []}),
          form: new Form({
                           docctexml_id: ''
                       }),
        }
    },
    props: {
      rowData: {
        type: Object,
        required: true
      },
      rowIndex: {
        type: Number
      }
    },
    methods: {
        onVerXml(xml) {
            Event.$emit('verXml', xml);
        },
        onReenvioXml (docctexml_id)
        {
                this.form.docctexml_id = docctexml_id;
                this.form.post('/api/monitorcte/reenvioXml').then(response =>
                {
                    new ReturnApi(response, this)
                    Event.$emit('reloadVuetable', response);
                })
                .catch(errors =>
                {
                    new ReturnApi(errors, this)
                });
            },
        onActivateDesactivate(action, data, tipo) {
            // Tipo = true = Checkbox
            if(tipo)
            {
                this.helpForm.statusRecord = [];
                this.helpForm.statusRecord.push({ id: data.gruponcm_id, status: action });
            }
            else
            {
                this.helpForm.statusRecord = [];
                this.$refs.vuetable.selectedTo.forEach((obj)=>{
                    this.helpForm.statusRecord.push({ id: obj, status: action })
                });
            }

            this.helpForm.post('/api/gruponcm/status').then(response =>
            {
                new ReturnApi(response, this);
                Event.$emit('reloadVuetable', data);
            })
            .catch(errors =>
            {
                new ReturnApi(errors, this)
            });
        },
  }
}
  </script>
